import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ProgressBar from '../progressBar/progressBar';
import { filterStepsTypes, filterSteps, baseRoutes } from '../../appSettings';
import './header.scss';

const Header = ({ activeFilterStep }) => {
  const [inFilterFlow, setInFilterFlow] = useState(false);
  const [hasBackgroundImage, setHasBackgroundImage] = useState(false);
  const location = useLocation();

  useEffect(()=> {
    setInFilterFlow(location.pathname !== `/${baseRoutes.START}` && location.pathname !== `/${baseRoutes.CONGRATULATIONS}`);
    setHasBackgroundImage(location.pathname === `/${filterStepsTypes.DESTINATION_TRAITS_SELECTION}` ||
      location.pathname === `/${filterStepsTypes.DESTINATION_TRAITS_DETAILS}`);
  }, [location.pathname]);

  const headerClasses = classnames({
    'vf-header': true,
    'vf-header-hidden': !inFilterFlow,
  });

  return (
    <header className={headerClasses}>
      { inFilterFlow && <ProgressBar activeStep={activeFilterStep.index} numberOfSteps={filterSteps.length} hasBackgroundImage={hasBackgroundImage} /> }
      { inFilterFlow && !hasBackgroundImage && <div className='vf-header__gradient' /> }
    </header>
  )
}

Header.propTypes = {
  activeFilterStep: PropTypes.shape({
    index: PropTypes.number,
    name: PropTypes.string,
  }),
};

Header.defaultProps = {
  activeFilterStep: {
    index: 0,
    name: filterStepsTypes.PRIMARY_CLASSIFICATIONS,
  },
};

const mapStateToProps = ({ siteSettings }) => {
  return {
    activeFilterStep: siteSettings.activeFilterStep,
  };
};

export default connect(mapStateToProps)(Header);